import store from "./store/index";
import * as helper from "./helper";
// import ev from "./deleteDbDataEvent";
// import * as socket from "./socket";

console.log(
  "%cZwing wPos",
  "color: #fee01d; font-family: sans-serif; font-size: 3.5em; font-weight: bolder; text-shadow: #fee01d 1px 1px;"
);

if (window.performance.navigation.type == 1) {
  // console.log("Reloaded");
  if (
    (store.state.system.settings.hasOwnProperty("vendor_app_menu") &&
      store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
      store.state.system.settings.vendor_app_menu.offline.status == 0 &&
      !window.navigator.onLine) ||
    (store.state.system.settings.hasOwnProperty("vendor_app_menu") &&
      store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") ==
        false &&
      !window.navigator.onLine)
  ) {
    setTimeout(() => {
      helper.checkPosStatus();
    }, 200);
  }
  store.dispatch("system/log", {
    type: "reload",
    log: {},
    status: "success",
  });
} else if (window.performance.navigation.type == 0) {
  store.dispatch("system/log", { type: "load", log: {}, status: "success" });
  window.addEventListener("load", () => {
    if (store.state.system.settings.hasOwnProperty("status"))
      helper.getSetting();
  });
  // store.commit("billing/setBillingMode", "normal");
  // console.log("Loaded for the first time!");
  if (
    window.navigator.onLine &&
    store.state.system.settings.hasOwnProperty("vendor_app_menu") &&
    store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
    store.state.system.settings.vendor_app_menu.offline.status == 1 &&
    store.state.system.isOffline
  ) {
    store.commit("system/setConnected", false);
    helper.verifyOfflineState();
  } else if (
    window.navigator.onLine == false &&
    store.state.system.settings.hasOwnProperty("vendor_app_menu") &&
    store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
    store.state.system.settings.vendor_app_menu.offline.status == 1
  ) {
    store.commit("system/setConnected", true);
    helper.switchToOffline();
  }
  // setTimeout(() => {
  //   ev();
  // }, 1000);
}

// window.onbeforeunload = function (event) {
//   if (
//     store.state.billing.billing.cart != "" &&
//     store.state.billing.billing.cart.data.length > 0 &&
//     process.env.VUE_APP_API_URL != 'http: //localhost:8008/zwingp/api/public/'
//   ) {
//     event.returnValue = "closing window";
//     return true;
//   }
// };

window.onunload = function() {
  if (store.state.system.payment_integrations.phonepe.transaction_id != "") {
    let url = process.env.VUE_APP_API_URL + "/payment-integration/window-close";
    let fd = new FormData();
    fd.append("vu_id", store.state.sessions.user.vu_id);
    fd.append("v_id", store.state.sessions.user.v_id);
    fd.append("api_token", store.state.sessions.user.api_token);
    fd.append(
      "transactionId",
      store.state.system.payment_integrations.phonepe.transaction_id
    );
    store.commit("system/clearPhonepeTransactionId");
    navigator.sendBeacon(url, fd);
  }
};

document.addEventListener("keydown", function(e) {
  if (
    e.ctrlKey &&
    e.shiftKey &&
    e.key == "R" &&
    process.env.VUE_APP_API_URL != "http://localhost/api/public/"
  ) {
    if (
      store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
      store.state.system.settings.vendor_app_menu.offline.status == 1 &&
      store.state.system.isOffline
    ) {
      return e.preventDefault();
    }
  }
});

window.onload = () => {
  store.commit("system/socketDataSyncStatus", false);
  store.commit("products/sync_error", false);
  store.commit("system/setSocketConnection", true);
  // socket.openConn();
};
